import React from 'react';
import { Skeleton } from '@cargomatic/ui';
import { useShipmentPods } from 'utils/hooks/useShipmentPods';
import PODButton from './PODButton';
/**
 * Fetches a shipment's POD document by foreign key and renders a lazy download
 * button. Shows a skeleton while the existence check loads, and returns null
 * when the shipment has no POD.
 */
export default function PodLink({ shipmentId, className, }) {
    const { data, isLoading } = useShipmentPods([shipmentId]);
    if (shipmentId && isLoading) {
        return React.createElement(Skeleton, { className: "h-8 w-8 rounded-md" });
    }
    const pod = shipmentId ? data === null || data === void 0 ? void 0 : data[shipmentId] : null;
    return React.createElement(PODButton, { pod: pod, podUrl: pod, className: className });
}
